import { Country, Product } from 'components/common/CommonTypes';
import { Countries, ProductTypes } from 'Constants/Common';

type PhoneConfig = {
    default: string;
    scenarios?: Partial<Record<Scenarios, string>>;
    products?: Partial<Record<Product, PhoneConfig>>;
};

export type Scenarios = 'payment';

export const PhoneRouting: Record<Country, PhoneConfig> = {
    [Countries.Uk]: {
        default: '0344 573 7581',

        scenarios: {
            payment: '0344 573 8118'
        },

        products: {
            [ProductTypes.Alloy]: {
                default: '0344 573 8129'
            },
            [ProductTypes.Cosmetic]: {
                default: '0344 573 8187'
            },
            [ProductTypes.Tyre]: {
                default: '0344 573 9271'
            }
        }
    },

    [Countries.Us]: {
        default: '888-200-6019'
    },

    [Countries.De]: {
        default: ''
    },
    [Countries.At]: {
        default: ''
    },
    [Countries.Es]: {
        default: ''
    }
};
